import { render } from "./StatedImplants.vue?vue&type=template&id=a50af9d0&scoped=true"
import script from "./StatedImplants.vue?vue&type=script&lang=js"
export * from "./StatedImplants.vue?vue&type=script&lang=js"

import "./StatedImplants.vue?vue&type=style&index=0&id=a50af9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50af9d0"]])

export default __exports__